@if (headerConfig(); as _headerConfig) {
  <ez-header
    [assetBucketUrl]="landingpageConfig()!.assetBucketUrl"
    [imageData]="_headerConfig"
    [organisationName]="landingpageConfig()!.organisation.name"
  />
}

<ng-content select="ez-banner"></ng-content>

<div class="page-content">
  <ng-content></ng-content>
</div>

@if (footerConfig(); as _footerConfig) {
  <ez-footer
    [assetBucketUrl]="landingpageConfig()!.assetBucketUrl"
    [imprintUrl]="landingpageConfig()!.organisation.web.imprintUrl"
    [dataPrivacyUrl]="landingpageConfig()!.organisation.web.dataProtectionUrl"
    [imageData]="_footerConfig"
    [organisationName]="landingpageConfig()!.organisation.name"
  />
}
